// Scroll Animation
const elements = document.querySelectorAll(".scroll-animation");
function checkScroll() {
  elements.forEach((el) => {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.85) {
      el.classList.add("visible");
    }
  });
}
window.addEventListener("scroll", checkScroll);
checkScroll();

// Thumb Animation
const thumbItems = document.querySelectorAll(".thumb-animate");
function checkVisibility() {
  thumbItems.forEach((el) => {
    const rect = el.getBoundingClientRect();
    const elementHeight = rect.height;
    const visibleHeight =
      Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

    if (visibleHeight >= elementHeight * 0.4) {
      el.classList.add("in-view");
    }
  });
}
window.addEventListener("scroll", checkVisibility);
checkVisibility();

// Reveile Animation
function singleScrollReveal(
  className = ".reveal-group",
  visibleOffset = 150,
  delay = 300,
) {
  function runReveal() {
    $(className).each(function () {
      var $parent = $(this);
      var windowHeight = $(window).height();
      var elementTop = $parent.offset().top - $(window).scrollTop();

      if (elementTop < windowHeight - visibleOffset) {
        $parent.children().each(function (index) {
          var $ele = $(this);
          setTimeout(function () {
            $ele.addClass("insight");
          }, index * delay);
        });
      }
    });
  }
  $(window).on("scroll", runReveal);
  $(document).ready(runReveal);
}
singleScrollReveal();

$(document).ready(function () {
  function checkVisibility() {
    $(".fade-in-scroll").each(function () {
      var elementTop = $(this).offset().top;
      var viewportBottom = $(window).scrollTop() + $(window).height();
      if (elementTop < viewportBottom - 1) {
        $(this).addClass("is-show");
      }
    });
  }
  checkVisibility();
  $(window).on("scroll", function () {
    checkVisibility();
  });
});

// Header Sticky

function headerSticky() {
  let lastScrollTop = 0;
  const header = document.querySelector(".header");
  if (!header) return;
  window.addEventListener("scroll", function () {
    const currentScroll = window.scrollY;
    if (currentScroll > 100) header.classList.add("header__inner_hove-active");
    else header.classList.remove("header__inner_hove-active");
    if (currentScroll <= 100) {
      header.style.transform = "translateY(0)";
    } else if (currentScroll < lastScrollTop) {
      header.style.transform = "translateY(0)";
    } else {
      header.style.transform = "translateY(-200%)";
    }
    lastScrollTop = currentScroll;
  });
}

headerSticky();

$(document).ready(function () {
  $(
    ".cocktail-showcase__mobi-play, .cocktail-showcase__play-btn, .single-product__video-icon",
  ).on("click", function () {
    const videoSrc = $(this).attr("data-att");
    const $section = $(this).closest("section");
    const $modal = $section.find(".modal");
    $modal.find("video source").attr("src", videoSrc);
    const video = $modal.find("video")[0];
    video.load();
    video.play();
    $modal.addClass("active");
    $("body").addClass("modal-open");
  });
  $(".modal__close").on("click", function () {
    const $modal = $(this).closest(".modal");
    const video = $modal.find("video")[0];
    video.pause();
    video.currentTime = 0;
    $modal.removeClass("active");
    $("body").removeClass("modal-open");
  });
  $(".overlay").on("click", function () {
    $(".modal.active").each(function () {
      const video = $(this).find("video")[0];
      video.pause();
      video.currentTime = 0;
      $(this).removeClass("active");
    });
    $("body").removeClass("modal-open");
  });
});

$(document).ready(function () {
  $(".faq-questions__title").first().addClass("active");
  $(".faq-questions__content").first().show();
  $(".faq-questions__title").click(function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).next(".faq-questions__content").slideUp();
    } else {
      $(".faq-questions__content").slideUp();
      $(".faq-questions__title").removeClass("active");
      $(this).addClass("active");
      $(this).next(".faq-questions__content").slideDown();
    }
  });
});

// single-product slider start

$(".single-product__big-img").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
  asNavFor: ".single-product__small-imgs",
  adaptiveHeight: true,
});
$(".single-product__small-imgs").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: ".single-product__big-img",
  centerMode: false,
  focusOnSelect: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },
  ],
});

// single-product slider end

// Start Collection Bundle Slider MObile & Desktop

$(".bundle-collections__items").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".bundle-collections__prev-arrow").click(function () {
  $(this).parent().parent().find(".slick-slider").slick("slickPrev");
});
$(".bundle-collections__next-arrow").click(function () {
  $(this).parent().parent().find(".slick-slider").slick("slickNext");
});

// End Collection Bundle Slider MObile & Desktop

// Start Collection Bundle Tab
$(document).ready(function () {
  $(".bundle-collections__btn").on("click", function (e) {
    e.preventDefault();
    var tabName = $(this).data("tab");
    $(".bundle-collections__btn").removeClass("active");
    $(this).addClass("active");
    $(".bundle-collections__box").removeClass("active");
    $(".bundle-collections__box").each(function () {
      if ($(this).attr("tab-content") === tabName) {
        $(this).addClass("active");
      }
    });
  });
});
// End Collection Bundle Tab

// Start Home Page Hero Bg color Remove

// $(document).ready(function () {
//   $(".hero__inner").on("click", function () {
//     $(this).toggleClass("bg-remove");
//   });
// });

// End Home Page Hero Bg color Remove

// Start Brand Gallery Slider Desktop & Mobile

$(".brand-gallery__items").slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      },
    },
  ],
});

// End Brand Gallery Slider Desktop & Mobile

// Start Marque Text Slider Only Mobile
if ($(Window).width() < 768) {
  $(document).ready(function () {
    var $text = $(".new-announcement__text");
    var content = $text.html();
    $text.html(content + content + content);
    $text.wrap('<div class="new-announcement__marquee-track"></div>');
  });
}
// End Marque Text Slider Only Mobile

// Start Home page Header Sticky (New Header)
$(document).ready(function () {
    let lastScrollTop = 0;
    const header = document.querySelector('.new-header');
    if (header) {
        const $announcementBar = $('.new-announcement');
        const $header = $('.new-header');
        function setAnnouncementOffset() {
            const announcementBarHeight = $announcementBar.length > 0 ? $announcementBar.outerHeight() : 0;
            $header.css('--announcement-offset', announcementBarHeight + 'px');
        }
        setAnnouncementOffset();
        window.addEventListener('resize', setAnnouncementOffset);
        window.addEventListener('scroll', function () {
            const currentScroll = window.scrollY;
            if (currentScroll > 100) {
                header.classList.add('header-sticky');
            } else {
                header.classList.remove('header-sticky');
            }
            if (currentScroll === 0) {
                header.style.transition = 'transform .3s ease-out';
                header.classList.remove('scroll-hide');
                header.classList.remove('scroll-started');
                header.classList.remove('scroll-up');
                void header.offsetHeight;
                header.style.transition = '';
            } else if (currentScroll < lastScrollTop) {
                header.classList.remove('scroll-hide');
                // header.classList.remove('scroll-started');
                header.classList.add('scroll-up');
            } else {
                header.classList.remove('scroll-up');
                header.classList.add('scroll-hide');
                header.classList.add('scroll-started');
            }
            lastScrollTop = currentScroll;
        });
    }
});
// End Home page Header Sticky (New Header)

// Start Cart Drawer
$(".new-header__cart").on("click", function (e) {
  e.preventDefault();
  $("body").addClass("cart-drawer-show");
});
$(".cart-drawer__close , .overlay").on("click", function () {
  $("body").removeClass("cart-drawer-show");
});
// End Cart Drawer

// start trusted-brands slider

if ($(window).width() < 768) {
  $(".trusted-brands__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
  });
}

// end trusted-brands slider

// start brand-highlights slider

if ($(window).width() < 768) {
  $(".brand-highlights__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 800,  
  });
}

// end brand-highlights slider

// Start testimonials slider

if ($(window).width() < 768) {
  $(".testimonials__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
  });
}

// end testimonials slider

if ($(".single-product__reviews").length) {
  $(".single-product__reviews").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    pauseOnHover: false,
    pauseOnFocus: false,
    adaptiveHeight: true,
  });
}


$(".image-gallery__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
  });

$(document).ready(function () {
  $(".cocktail-showcase__item").each(function () {
    var $item = $(this);
    var videoUrl = $item.find("[data-att]").first().attr("data-att");

    if (videoUrl) {
      var tempVideo = document.createElement("video");
      tempVideo.src = videoUrl;
      tempVideo.preload = "metadata";

      tempVideo.onloadedmetadata = function () {
        var duration = tempVideo.duration;
        var minutes = Math.floor(duration / 60);
        var seconds = Math.floor(duration % 60);
        var formattedSeconds = seconds < 10 ? "0" + seconds : seconds;
        var timeString = "Watch · " + minutes + ":" + formattedSeconds;

        $item
          .find(
            ".cocktail-showcase__mobi-play-text, .cocktail-showcase__play-btn-text",
          )
          .text(timeString);
      };
    }
  });
});

function handleLoading($btn, duration = 1200) {
  const $parent = $btn.parent();
  clearTimeout($parent.data("loadingTimeout"));
  $parent.addClass("loading");
  const timeoutId = setTimeout(function () {
    $parent.removeClass("loading");
  }, duration);
  $parent.data("loadingTimeout", timeoutId);
}
$(document).on("click", ".click-loading", function (e) {
  e.preventDefault();
  handleLoading($(this));
});

// $(".new-header__search").on("click", function () {
//   $("body").addClass("search-show");
// });
// $(".search__close").on("click", function () {
//   $("body").removeClass("search-show");
// });

$(document).ready(function () {
  $(".new-header__search").on("click", function () {
    $("body").addClass("search-show");
  });
  $(".search__close").on("click", function () {
    $("body").removeClass("search-show");
  });
});





$(window).on('scroll load', function () {
    let activeCollection = '/collections';
    const offset = 60;

    $('.featured-bundles__inner').each(function () {
        const top = this.getBoundingClientRect().top;

        if (top <= offset) {
            activeCollection = $(this).data('collection');
        }
    });

    if (activeCollection) {
        $('.list-collections .product-categories__url').removeClass('active');

        $('.list-collections .product-categories__url').each(function () {
            if ($(this).attr('href') === activeCollection) {
                $(this).addClass('active');
            }
        });
    }
});




$('.single-product__story-items').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: 'linear',
    mobileFirst: true,
    variableWidth: true,

    responsive: [
        {
            breakpoint: 768,
            settings: 'unslick'
        }
    ]
});








$(".new-header__mobile-bar").on("click", function () {
    $(this).toggleClass("active");
    $("body").toggleClass("menu-drawer-show");
});
$(".menu-drawer__item_has-menu").on("click", function () {
    $(this).find(".menu-drawer__has-menu").addClass("active");
});
$(".menu-drawer__has-menu-back").on("click", function (event) {
    event.stopPropagation();
    $(this).closest(".menu-drawer__has-menu").removeClass("active");
});

$(window).on("scroll", function () {
    if ($(window).scrollTop() > 0) {
        $(".menu-drawer").addClass("menu-drawer-height");
    } else {
        $(".menu-drawer").removeClass("menu-drawer-height");
    }
});








const recipeVideoWrap = document.querySelector('.recipe-details__video-wrap');

if (recipeVideoWrap) {
    const recipeVideoPoster = recipeVideoWrap.querySelector('.recipe-details__video-poster-img');
    const recipeVideoPlay = recipeVideoWrap.querySelector('.recipe-details__video-play-icon');
    const recipeVideo = recipeVideoWrap.querySelector('.recipe-details__video');
    const recipeVideoIframe = recipeVideo.querySelector('iframe');

    recipeVideoPlay.addEventListener('click', function () {
        const videoUrl = this.getAttribute('data-attr');
        let videoId = '';

        try {
            const url = new URL(videoUrl);

            // https://youtu.be/K8V8uFsYgvk?si=...
            if (url.hostname === 'youtu.be') {
                videoId = url.pathname.split('/')[1];
            }

            // https://www.youtube.com/watch?v=IhyxwxKTrNo
            else if (url.hostname.includes('youtube.com')) {
                videoId = url.searchParams.get('v');
            }
        } catch (e) {
            console.error('Invalid YouTube URL:', videoUrl);
        }

        if (!videoId) return;

        recipeVideoIframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;

        recipeVideoPoster.style.display = 'none';
        recipeVideoPlay.style.display = 'none';
        recipeVideo.style.display = 'block';
    });
}